export const pluralize = (
  number: number,
  forms: [string, string, string] | [string, string],
): string => {
  const absNumber = Math.abs(number);
  const lastDigit = absNumber % 10;
  const lastTwoDigits = absNumber % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return forms[2] ?? forms[1];
  }
  if (lastDigit === 1) {
    return forms[0];
  }
  if (lastDigit >= 2 && lastDigit <= 4) {
    return forms[1];
  }
  return forms[2] ?? forms[1];
};
